import BaseApi from './baseApi';
import IStock from '../models/IStock';
import IInbound from '../models/IInbound';
import IOutbound from '../models/IOutbound';
import { SELL_STATUS_EXCLUDED_SQL_FILTER } from '../../config/constants';
export default class CustomerDashboardApi extends BaseApi {
    constructor() {
        super("dataaccess", "CustomerDashboard");
    }

    async GetStockGroupByPalletsAndCustomer(idCustomer: string) : Promise<IStock[]> {
        let json : string = this.getJsonReadGroupByPalletsAndCustomer(idCustomer);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var stock: IStock[] = [];
            stock = response.data as IStock[];
            return stock;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetStockGroupByCustomer(idCustomer: string) : Promise<IStock[]> {
        let json : string = this.getJsonReadGroupByCustomer(idCustomer);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var stock: IStock[] = [];
            stock = response.data as IStock[];
            return stock;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetInboundsByCustomer(idCustomer : string) : Promise<IInbound[]> {
        let json : string = this.getJsonReadInboundsWithIdCustomer(idCustomer);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inbounds: IInbound[] = [];
            inbounds = response.data as IInbound[];
            return inbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetOutboundsByCustomer(idCustomer : string) : Promise<IOutbound[]> {
        let json : string = this.getJsonReadOutboundsWithIdCustomer(idCustomer);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outbounds: IOutbound[] = [];
            outbounds = response.data as IOutbound[];
            return outbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    private getJsonReadOutboundsWithIdCustomer(idCustomer: string) : any {
        const json = {
            "fields": [{
                "Item1": "Outbounds",
                "Item2": "id"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusOutbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Outbounds",
                "Item2": "code"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateOut"
            }, {
                "Item1": "Outbounds",
                "Item2": "dossierNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "liters"
            }, {
                "Item1": "Outbounds",
                "Item2": "deliveriesNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "codeDestination"
            }],
            "tables": [{
                "Item1": "Outbounds"
            }, {
                "Item1": "Customers"
            }],
            "joins": [{
                "Item1": "Outbounds",
                "Item2": "idCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Outbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCustomer",
                "Item3": "=",
                "Item4": idCustomer
            }],
            "orderBy": [{
                "Item1": "Outbounds.DateOut desc"
            }]
        };
        return json;
    }

    private getJsonReadInboundsWithIdCustomer(idCustomer: string) : any {
        const json = {
            "fields": [{
                "Item1": "Inbounds",
                "Item2": "id"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusInbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Inbounds",
                "Item2": "code"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateIn"
            }, {
                "Item1": "Inbounds",
                "Item2": "description"
            }, {
                "Item1": "Inbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "weight"
            }, {
                "Item1": "Inbounds",
                "Item2": "liters"
            }, {
                "Item1": "Inbounds",
                "Item2": "codeDestination"
            }],
            "tables": [{
                "Item1": "Inbounds"
            }, {
                "Item1": "Customers"
            }],
            "joins": [{
                "Item1": "Inbounds",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Inbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCustomer",
                "Item3": "=",
                "Item4": idCustomer
            }],
            "orderBy": [{
                "Item1": "Inbounds.DateIn desc"
            }]
        };
        return json;
    }

    private getJsonReadGroupByPalletsAndCustomer(idCustomer: string) : any {
        const json = {
            "fields": [{
                "Item1": "*, (B.PalletsAmount - B.PalletsAmountSell) AS AvailablePalletsAmountFinal, (B.AvailableCases - B.SellCases) AS AvailableCasesFinal, (B.AvailableGoods - B.SellGoods) AS AvailableGoodsFinal  FROM (SELECT A.warehouseName, A.customerName, A.codeInbounds, A.codeDestination, A.idInbound, A.IdInboundDeliveryNoteDetail, A.referenceInboundCode, A.idGood, A.idListPallet, A.goodName, A.listPalletName, SUM(A.palletsAmount) AS palletsAmount, SUM(A.totalCases) AS totalCases, SUM(A.AllocatedCases) AS AllocatedCases, SUM(A.AvailableCases) AS AvailableCases, A.goodsPerCase, SUM(A.totalGoods) AS totalGoods, SUM(A.AllocatedGoods) AS AllocatedGoods, SUM(A.AvailableGoods) AS AvailableGoods, A.bestBeforeDate, A.language, A.documentation, ISNULL((SELECT SUM(SellsDetail.PalletsAmount) FROM SellsDetail  LEFT OUTER JOIN Sells ON (SellsDetail.IdSell = Sells.Id) WHERE IdGood = A.IdGood AND IdInbound = A.IdInbound AND IdListPallet = A.IdListPallet AND CasesAmountPallet = (A.TotalCases / A.PalletsAmount) AND SellsDetail.Deleted = 0 " + SELL_STATUS_EXCLUDED_SQL_FILTER + "), 0) AS palletsAmountSell, ISNULL((SELECT SUM(SellsDetail.CasesAmountPallet) * SUM(SellsDetail.PalletsAmount) FROM SellsDetail  LEFT OUTER JOIN Sells ON (SellsDetail.IdSell = Sells.Id) WHERE IdGood = A.IdGood AND IdInbound = A.IdInbound AND IdListPallet = A.IdListPallet AND CasesAmountPallet = (A.TotalCases / A.PalletsAmount) AND SellsDetail.Deleted = 0 " + SELL_STATUS_EXCLUDED_SQL_FILTER + "), 0) AS sellCases, ISNULL((SELECT SUM(SellsDetail.GoodsPerCase) * SUM(SellsDetail.CasesAmountPallet) * SUM(SellsDetail.PalletsAmount) FROM SellsDetail  LEFT OUTER JOIN Sells ON (SellsDetail.IdSell = Sells.Id) WHERE IdGood = A.IdGood AND IdInbound = A.IdInbound AND IdListPallet = A.IdListPallet AND CasesAmountPallet = (A.TotalCases / A.PalletsAmount) AND SellsDetail.Deleted = 0 " + SELL_STATUS_EXCLUDED_SQL_FILTER + "), 0) AS sellGoods  FROM (SELECT Warehouses",
                "Item2": "name as warehouseName"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "ISNULL(Inbounds",
                "Item2": "code, '') as codeInbounds"
            }, {
                "Item1": "Inbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Inbounds",
                "Item2": "id as idInbound"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode as referenceInboundCode"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "Id as IdInboundDeliveryNoteDetail"
            }, {
                "Item1": "Goods",
                "Item2": "id as idGood"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "id as idListPallet"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as listPalletName"
            }, {
                "Item1": "COUNT(DISTINCT(StockDetail",
                "Item2": "idPallet)) as palletsAmount"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalCases) as totalCases"
            }, {
                "Item1": "StockDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalGoods) as totalGoods"
            }, {
                "Item1": "ISNULL((SELECT SUM(OutboundsDetail",
                "Item2": "TotalCases) FROM OutboundsDetail WHERE StockDetail.IdWarehouse = OutboundsDetail.IdWarehouse AND IdGood = StockDetail.IdGood AND Id NOT IN (SELECT IdOutboundDetail FROM OutboundsDeliveryNotesDetail WHERE Deleted = 0) AND IdInboundDeliveryNoteDetail = StockDetail.IdInboundDeliveryNoteDetail AND Deleted = 0), 0) as AllocatedCases"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalCases) - ISNULL((SELECT SUM(TotalCases) FROM OutboundsDetail WHERE StockDetail.IdWarehouse = OutboundsDetail.IdWarehouse AND IdGood = StockDetail.IdGood AND Id NOT IN (SELECT IdOutboundDetail FROM OutboundsDeliveryNotesDetail WHERE Deleted = 0) AND IdInboundDeliveryNoteDetail = StockDetail.IdInboundDeliveryNoteDetail AND Deleted = 0), 0) as AvailableCases"
            }, {
                "Item1": "ISNULL((SELECT SUM(OutboundsDetail",
                "Item2": "TotalGoods) FROM OutboundsDetail WHERE StockDetail.IdWarehouse = OutboundsDetail.IdWarehouse AND IdGood = StockDetail.IdGood AND Id NOT IN (SELECT IdOutboundDetail FROM OutboundsDeliveryNotesDetail WHERE Deleted = 0) AND IdInboundDeliveryNoteDetail = StockDetail.IdInboundDeliveryNoteDetail AND Deleted = 0), 0) as AllocatedGoods"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalGoods) - ISNULL((SELECT SUM(TotalGoods) FROM OutboundsDetail WHERE StockDetail.IdWarehouse = OutboundsDetail.IdWarehouse AND IdGood = StockDetail.IdGood AND Id NOT IN (SELECT IdOutboundDetail FROM OutboundsDeliveryNotesDetail WHERE Deleted = 0) AND IdInboundDeliveryNoteDetail = StockDetail.IdInboundDeliveryNoteDetail AND Deleted = 0), 0) as AvailableGoods"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "bestBeforeDate"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "documentation"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCompanySource"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "StockDetail",
                "Item2": "idWarehouse"
            }],
            "tables": [{
                "Item1": "StockDetail"
            }, {
                "Item1": "Warehouses"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "Goods"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDetail"
            }, {
                "Item1": "Inbounds"
            }],
            "conditions": [{
                "Item1": "StockDetail",
                "Item2": "idCustomer",
                "Item3": "=",
                "Item4": idCustomer,
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDeliveryNoteDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdNoticeOfLossDetail",
                "Item3": "IS",
                "Item4": "null"
            }],
            "joins": [{
                "Item1": "StockDetail",
                "Item2": "IdWarehouse",
                "Item3": "Warehouses",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdGood",
                "Item3": "Goods",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdInboundDeliveryNoteDetail",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDetail",
                "Item3": "InboundsDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "IdInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }],
            "groupBy": [{
                "Item1": "StockDetail.idWarehouse"
            }, {
                "Item1": "Warehouses.name"
            }, {
                "Item1": "StockDetail.IdWarehouse"
            }, {
                "Item1": "Customers.name"
            }, {
                "Item1": "Goods.id"
            }, {
                "Item1": "Goods.name"
            }, {
                "Item1": "Inbounds.code"
            }, {
                "Item1": "Inbounds.codeDestination"
            }, {
                "Item1": "Inbounds.Id"
            }, {
                "Item1": "Inbounds.referenceInboundCode"
            }, {
                "Item1": "ListPalletTypes.id"
            }, {
                "Item1": "ListPalletTypes.name"
            }, {
                "Item1": "StockDetail.idCustomer"
            }, {
                "Item1": "StockDetail.totalCases"
            }, {
                "Item1": "StockDetail.goodsPerCase"
            }, {
                "Item1": "StockDetail.totalGoods"
            }, {
                "Item1": "InboundsDetail.bestBeforeDate"
            }, {
                "Item1": "InboundsDeliveryNotesDetail.id"
            }, {
                "Item1": "InboundsDetail.language"
            }, {
                "Item1": "InboundsDetail.documentation"
            }, {
                "Item1": "StockDetail.IdCompanySource"
            }, {
                "Item1": "StockDetail.IdInboundDeliveryNoteDetail"
            }, {
                "Item1": "StockDetail.IdCompanyDestination"
            }, {
                "Item1": "StockDetail.IdGood) A GROUP BY A.warehouseName, A.customerName, A.codeInbounds, A.codeDestination, A.idInbound, A.IdInboundDeliveryNoteDetail, A.referenceInboundCode, A.idGood, A.idListPallet, A.goodName, A.listPalletName, A.goodsPerCase, A.bestBeforeDate, A.language, A.documentation, A.Totalcases, A.PalletsAmount) B"
            }],
            "orderBy": [{
                "Item1": "B.goodName"
            }, {
                "Item1": "B.codeInbounds"
            }]
        };
        return json;
    }

    private getJsonReadGroupByCustomer(idCustomer: string) : any {
        const json = {
            "fields": [{
                "Item1": "Warehouses",
                "Item2": "name as warehouseName"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "Inbounds",
                "Item2": "code as codeInbounds"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode as referenceInboundCode"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as listPalletName"
            }, {
                "Item1": "COUNT(DISTINCT(StockDetail",
                "Item2": "idPallet)) as palletsAmount"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalCases) as totalCases"
            }, {
                "Item1": "StockDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalGoods) as totalGoods"
            }, {
                "Item1": "format(StockDetail",
                "Item2": "dateIn, 'dd/MM/yyyy') as dateIn"
            }, {
                "Item1": "format(StockDetail",
                "Item2": "dateOut, 'dd/MM/yyyy') as dateOut"
            }, {
                "Item1": "StockDetail",
                "Item2": "location"
            }, {
                "Item1": "format(InboundsDetail",
                "Item2": "bestBeforeDate, 'dd/MM/yyyy') as bestBeforeDate"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "documentation"
            }],
            "tables": [{
                "Item1": "StockDetail"
            }, {
                "Item1": "Warehouses"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "Goods"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDetail"
            }, {
                "Item1": "Inbounds"
            }],
            "conditions": [{
                "Item1": "StockDetail",
                "Item2": "idCustomer",
                "Item3": "=",
                "Item4": idCustomer,
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDeliveryNoteDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdNoticeOfLossDetail",
                "Item3": "IS",
                "Item4": "null"
            }],
            "joins": [{
                "Item1": "StockDetail",
                "Item2": "IdWarehouse",
                "Item3": "Warehouses",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdGood",
                "Item3": "Goods",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdInboundDeliveryNoteDetail",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDetail",
                "Item3": "InboundsDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "IdInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }],
            "groupBy": [{
                "Item1": "Warehouses.name"
            }, {
                "Item1": "Customers.name"
            }, {
                "Item1": "Goods.name"
            }, {
                "Item1": "Inbounds.code"
            }, {
                "Item1": "Inbounds.referenceInboundCode"
            }, {
                "Item1": "ListPalletTypes.name"
            }, {
                "Item1": "StockDetail.totalCases"
            }, {
                "Item1": "StockDetail.goodsPerCase"
            }, {
                "Item1": "StockDetail.totalGoods"
            }, {
                "Item1": "StockDetail.dateIn"
            }, {
                "Item1": "StockDetail.dateOut"
            }, {
                "Item1": "StockDetail.location"
            }, {
                "Item1": "InboundsDetail.bestBeforeDate"
            }, {
                "Item1": "InboundsDetail.language"
            }, {
                "Item1": "InboundsDetail.documentation"
            }]
        };
        return json;
    }
}
